<template>
  <v-navigation-drawer
    v-if="user"
    v-model="drawer"
    expand-on-hover
    mini-variant
    permanent
    absolute
    elevation="2"
    color="#666666"
    dark
    style="z-index:100"
  >
    <v-list nav class="py-0">
      <v-list-item two-line class="profile">
        <v-list-item-avatar>
          <img :src="user.photoURL" :alt="user.displayName" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="profile-name">
            {{ user.displayName }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>

    <template>
      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.link"
          active-class="router-link-active"
          link
          replace
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="router-link">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <template v-slot:append>
      <v-list>
        <v-list-item link to="/email-templates" replace>
          <v-list-item-icon>
            <v-icon>mdi-palette-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="router-link"
              >Email Templates</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/conf" replace>
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="router-link">Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout()" link>
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="router-link">Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>
<script>
import firebase from "firebase";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      drawer: true,
      items: [
        {
          title: "Leads",
          icon: "mdi-account-group",
          link: "/leads"
        },
        // {
        //   title: "Appointments",
        //   icon: "mdi-calendar-multiselect",
        //   link: "/apts"
        // },
        // {
        //   title: "SMS",
        //   icon: "mdi-cellphone-message",
        //   link: "/sms"
        // },
        {
          title: "EDM",
          icon: "mdi-email-open-multiple-outline",
          link: "/edm"
        }
        // {
        //   title: "Contacts",
        //   icon: "mdi-contacts-outline",
        //   link: "/contacts"
        // },
        // {
        //   title: "Events",
        //   icon: "mdi-calendar-star",
        //   link: "/events"
        // }
        // {
        //   title: "Products",
        //   icon: "mdi-book-multiple",
        //   link: "/products"
        // }
      ],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "full_name"
        },
        { text: "Phone", value: "phone", sortable: false },
        { text: "PostCode", value: "postcode", sortable: false }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    }
  },
  methods: {
    ...mapActions("user", { updateUser: "updateUser" }),
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          localStorage.setItem("login", false);
          this.$router.push("login");
        });
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.profile {
  padding: 0 !important;

  .profile-name {
    padding-left: 16px;
  }
}

.router-link {
  color: $light6;
  padding-left: 16px;
  text-decoration: none;
}

.router-link-active {
  background-color: $dark-bg-0;
  color: $gold !important;
}
</style>
